import React from 'react';
import { Collapse, CollapsePanelProps } from 'antd';
import styled from 'styled-components';
import { GlobalToken } from 'antd';

import IconChevronDown from '@/assets/icon-chevron-down.svg?react';

const EPPanel = ({ header, ...rest }: { header: React.ReactNode } & CollapsePanelProps) => {
  const headerEl = (
    <div className="ellipsis" style={{ width: '100%' }}>
      {header}{' '}
    </div>
  );

  return <Collapse.Panel header={headerEl} {...rest} />;
};

const EPCollapse = ({ children, ...rest }: { children: React.ReactNode }) => {
  const arrow = (p: { isActive: boolean }) => {
    return p.isActive ? <IconChevronDown /> : <IconChevronDown style={{ transform: 'rotate(-90deg)' }} />;
  };

  return (
    <StyledCollapse ghost={true} expandIcon={arrow} {...rest}>
      {children}
    </StyledCollapse>
  );
};

const StyledCollapse = styled(Collapse)<{ theme: { token: GlobalToken } }>`
  &.ant-collapse {
    margin-bottom: ${({ theme: { token } }) => token.marginXS}px;

    .ant-collapse-header {
      display: flex;
      background-color: ${({ theme: { token } }) => token.colorBgElevated};
      color: ${({ theme: { token } }) => token.colorText};
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      height: 36px;
      padding: ${({ theme: { token } }) => token.paddingXS}px;

      .ant-collapse-arrow {
        width: 20px;
        height: 20px;
        margin-right: ${({ theme: { token } }) => token.marginXS}px;
      }

      .ant-collapse-header-text {
        overflow: hidden;
      }

      .ant-collapse-expand-icon {
        padding-inline-end: 0;
      }
    }

    .ant-collapse-item {
      margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
    }

    .ant-collapse-content {
      color: ${({ theme: { token } }) => token.colorText};
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    }
  }
`;

EPCollapse.EPPanel = EPPanel;

export default EPCollapse;
